import { render, staticRenderFns } from "./MyInvites.vue?vue&type=template&id=4f4a9b05&scoped=true"
import script from "./MyInvites.vue?vue&type=script&lang=js"
export * from "./MyInvites.vue?vue&type=script&lang=js"
import style0 from "./MyInvites.vue?vue&type=style&index=0&id=4f4a9b05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a9b05",
  null
  
)

export default component.exports